import { Dossier } from '@sc/data-access-models';

export interface RouterInfoActionTypes {
  dossier?: Dossier;
  dialogType: 'operation-type-infos' | 'adas-infos' | 'weather-infos';
}
